<template>
  <div v-if="hunter" class="hunter">
    <div v-if="editable" class="edit" @click="edit">
      <svg-icon name="edit" />
    </div>
    <el-row>
      <el-col :span="3" class="avatar">
        <el-avatar icon="el-icon-user-solid" :src="hunter.profile.avatar | avatar64" />
      </el-col>
      <el-col :span="18" class="name">
        {{ hunter.profile.name }}
      </el-col>
    </el-row>
    <el-row class="details">
      <el-col :span="10">
        <span class="label">{{ $t('whatsApp') }}</span>
        <span class="value">{{ hunter.profile.phone }}</span>
      </el-col>
      <el-col :span="10">
        <span class="label">{{ $t('email') }}</span>
        <span class="value">{{ hunter.email }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: {
      hunter: {
        type: Object
      },
      editable: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      edit() {
        this.$emit('edit', this.hunter)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .hunter {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 30px;
    color: $color-text-regular;
    border-bottom: 1px solid $border-color-lighter;

    .edit {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 600;
      cursor: pointer;

      .svg-icon {
        width: 16px;
        height: 16px;
        color: $border-color-light;
      }

      .svg-icon:hover {
        color: $menu-icon-color;
      }
    }

    .avatar {
      min-width: 50px;
    }

    .name {
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
    }

    .details {
      padding-top: 10px;

      .label {
        font-size: 12px;
        line-height: 16px;
        color: $color-text-label;
      }

      .value {
        display: block;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
